import { render } from "./containerContent.vue?vue&type=template&id=2bb2da41&scoped=true"
import script from "./containerContent.vue?vue&type=script&lang=ts"
export * from "./containerContent.vue?vue&type=script&lang=ts"

import "./containerContent.vue?vue&type=style&index=0&id=2bb2da41&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2bb2da41"

export default script